import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['BettingStatus', 'Markets', 'AppUrls'],
  endpoints: (builder) => ({
    // Get all markets endpoint
    getAllMarkets: builder.query({
      query: (userId) => ({
        url: userId ? `/api/admin/all-markets?userId=${userId}` : '/api/admin/all-markets',
        method: 'GET',
      }),
      providesTags: ['Markets'],
    }),

    // Get betting status endpoint
    getBettingStatus: builder.query({
      query: (userId) => ({
        url: `/api/users/${userId}/betting-status`,
        method: 'GET',
      }),
      providesTags: (result, error, userId) => [{ type: 'BettingStatus', id: userId }],
    }),

    // Lock/unlock a market type globally
    lockMarket: builder.mutation({
      query: ({ type, locked, userId }) => ({
        url: '/api/admin/markets/lock',
        method: 'PATCH',
        body: { type, locked, userId },
      }),
      invalidatesTags: ['Markets'],
    }),

    // Update betting status endpoint
    updateBettingStatus: builder.mutation({
      query: ({ userId, blocked, type = 'all', cascade = true }) => ({
        url: `/api/users/${userId}/betting-status?cascade=${cascade}`,
        method: 'PATCH',
        body: { blocked, type },
      }),
      invalidatesTags: (result, error, { userId }) => [{ type: 'BettingStatus', id: userId }],
    }),

    // Get Finance cash ledger
    getFinanceClients: builder.query({
      query: ({ from = '', to = '', type = '', userType = '', page = 1, limit = 50 } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        if (type) params.append('type', type);
        if (userType) params.append('userType', userType);
        return { url: `/api/admin/cash-ledger?${params.toString()}`, method: 'GET' };
      },
    }),

    // Get available app URLs (brand domains) — used when creating a SuperAdmin
    getAppUrls: builder.query({
      query: () => ({ url: '/api/appurls', method: 'GET' }),
      providesTags: ['AppUrls'],
    }),

    // Domain ki client-site theme set karo (Site Theme page). Backend AppUrl me `theme` field chahiye
    // — docs: sky99/docs/SITE_THEME_BACKEND.md
    updateAppUrlTheme: builder.mutation({
      query: ({ id, theme }) => ({ url: `/api/appurls/${id}`, method: 'PUT', body: { theme } }),
      invalidatesTags: ['AppUrls'],
    }),
  }),
});

export const {
  useGetAllMarketsQuery,
  useGetBettingStatusQuery,
  useLockMarketMutation,
  useUpdateBettingStatusMutation,
  useGetFinanceClientsQuery,
  useGetAppUrlsQuery,
  useUpdateAppUrlThemeMutation,
} = userApi;
